function toggleQuickView(event) {
    if (dragging) return;

    var target = event.target.closest(".quickviewToggle, .quickviewClose");
    if (target) {
        event.preventDefault();
        event.stopPropagation();

        if (
            target.classList.contains("quickviewActive") ||
            target.classList.contains("quickviewClose")
        ) {
            // Close open quickview and move to end
            closeQuickview();
        } else {
            // Remove old quickview and move to end
            closeQuickview();

            // Open new quickview and move to correct location
            openQuickView(target);
        }
    }
}

function openQuickView(element) {
    element.classList.add("quickviewActive");
    document.querySelector("#cast-listing .quickview").innerHTML =
        element.nextElementSibling.innerHTML;
    moveQuickView();

    // Scroll to quickview modal
    element.scrollIntoView();
}

function moveQuickView() {
    var target = document.querySelector(
        ".quickviewToggle.quickviewActive"
    ).parentElement;

    if (target) {
        var currentPlacement =
            Array.prototype.indexOf.call(
                document.querySelector("#cast-listing").children,
                target
            ) + 1;

        /**
         *  NOTICE !!!
         *  These must match the breakpoints defined in src/scss/components/_page-listingTeam.scss
         **/
        if (window.widthREMs < 35) {
            // 1 column, can be moved directly after
            target.insertAdjacentElement(
                "afterend",
                document.querySelector("#cast-listing .quickview")
            );
        } else if (window.widthREMs < 50) {
            // 2 columns, move to start of next row
            var insertAfter = Math.ceil(currentPlacement / 2) * 2 - 1;
            if (
                insertAfter <= 0 ||
                insertAfter >
                    document.querySelector("#cast-listing").children.length
            ) {
                insertAfter =
                    document.querySelector("#cast-listing").children.length - 1;
            }
            document
                .querySelector("#cast-listing")
                .children[insertAfter].insertAdjacentElement(
                    "afterend",
                    document.querySelector("#cast-listing .quickview")
                );
        } else if (window.widthREMs < 60) {
            // 3 columns, move to start of next row
            var insertAfter = Math.ceil(currentPlacement / 3) * 3 - 1;
            if (
                insertAfter <= 0 ||
                insertAfter >
                    document.querySelector("#cast-listing").children.length
            ) {
                insertAfter =
                    document.querySelector("#cast-listing").children.length - 1;
            }
            document
                .querySelector("#cast-listing")
                .children[insertAfter].insertAdjacentElement(
                    "afterend",
                    document.querySelector("#cast-listing .quickview")
                );
        } else {
            // 4 columns, move to start of next row
            var insertAfter = Math.ceil(currentPlacement / 4) * 4 - 1;
            if (
                insertAfter <= 0 ||
                insertAfter >=
                    document.querySelector("#cast-listing").children.length
            ) {
                insertAfter =
                    document.querySelector("#cast-listing").children.length - 1;
            }

            document
                .querySelector("#cast-listing")
                .children[insertAfter].insertAdjacentElement(
                    "afterend",
                    document.querySelector("#cast-listing .quickview")
                );
        }
    }
}

function closeQuickview() {
    // Close any open quickviews
    var element = document.querySelector(".quickviewToggle.quickviewActive");
    if (element) {
        document.querySelector(
            ".quickviewToggle.quickviewActive + .quickview-wrapper"
        ).innerHTML = document.querySelector(
            "#cast-listing .quickview"
        ).innerHTML; // Move quickview contents back to original location

        // Move quickview back to end
        if (document.querySelector("#cast-listing")) {
            document.querySelector("#cast-listing .quickview").innerHTML = "";
            document
                .querySelector("#cast-listing")
                .appendChild(document.querySelector("#cast-listing .quickview"));
        }
        element.classList.remove("quickviewActive");
    }
}

document.addEventListener("click", toggleQuickView);
document.addEventListener("touchend", toggleQuickView);

window.addEventListener("orientationchange", closeQuickview);
window.addEventListener("resize", closeQuickview);